import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoPiezometerLight from '../../../piezometry/dto/DtoPiezometerLight'
import WatershedAction from '../../../referencial/components/watershed/actions/WatershedAction'
import { hasValue } from '../../../utils/NumberUtil'
import { execByType } from '../../../utils/StationUtils'
import { arrayOf, getLabel, getMapStateToProps, getPropTypes } from '../../../utils/StoreUtils'
import Select from '../Select'

const propsToFetch = {
    watersheds: true,
    stationTypes: true,
    stationsWithWatershed: false,
    qualitometers: false,
    hydrometricStations: false,
}

class WatershedSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            watershed: -1,
            stations: [],
        }
    }

    componentDidMount() {
        // AppStore.dispatch(SieauAction.fetch(propsToFetch))
    }

    onChangeFilter = (value) => {
        if (hasValue(value)) {
            this.setState({ watershed: value })
            this.props.fetchStationsWithWatershed(value).then(this.onChangeStations)
        } else {
            this.props.onChange([], -1)
            this.setState({ watershed: -1, stations: [] })
        }
    }

    onChangeStations = () => {
        const stations = execByType(this.props.stationType, {
            quality: () => this.props.stationsWithWatershed.filter(s => getLabel(this.props.stationTypes, s.type) === 'QUALITOMETER').map(s => this.props.qualitometers.find(q => q.id == s.id)),
            piezometry: () => this.props.stationsWithWatershed.filter(s => getLabel(this.props.stationTypes, s.type) === 'PIEZOMETER').map(s => this.props.piezometers.find(q => q.id == s.id)),
            hydrometry: () => this.props.stationsWithWatershed.filter(s => getLabel(this.props.stationTypes, s.type) === 'HYDRO').map(s => this.props.hydrometricStations.find(q => q.id == s.id)),
            default: () => this.props.stationsWithWatershed.map(s => {
                switch (getLabel(this.props.stationTypes, s)) {
                    case 'QUALITOMETER':
                        return this.props.qualitometers.find(q => q.id === s.id)
                    case 'PIEZOMETER':
                        return this.props.piezometers.find(q => q.id === s.id)
                    case 'HYDRO':
                        return this.props.hydrometricStations.find(q => q.id === s.id)
                    default:
                        return {}
                }
            }),
        })
        this.props.onChange(stations, this.state.watershed)
        this.setState({ stations: stations.length })
    }

    render() {
        return (
            <Select
                col={this.props.col}
                label={this.props.title || i18n.watershed}
                options={this.props.watersheds}
                onChange={(v) => this.onChangeFilter(v)}
                value={this.state.watershed}
                keyValue='id'
                nullLabel={this.props.nullLabel || i18n.none}
            />
        )
    }
}


WatershedSelect.propTypes = getPropTypes(propsToFetch, {
    className: PropTypes.string,
    title: PropTypes.string,
    col: PropTypes.number,
    nullLabel: PropTypes.string,
    disabled: PropTypes.bool,
    withBookmarks: PropTypes.bool,
    stationType: PropTypes.stationType,
    onChange: PropTypes.func,
    piezometers: arrayOf(DtoPiezometerLight),
})

WatershedSelect.defaultProps = {
    label: '',
    className: '',
    stationType: '',
}

const mapStateToProps = store => getMapStateToProps(propsToFetch, {
    piezometers: store.PiezometryReducer.piezometersLight,
})

const mapDispatchToProps = {
    fetchStationsWithWatershed: WatershedAction.fetchStationsWithWatershed,
}

export default connect(mapStateToProps, mapDispatchToProps)(WatershedSelect)